import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { renderHTML } from '../helpers';
import { P } from '.';

class LongText extends Component {
    state = { showAll: false }
    showMore = () => this.setState({ showAll: true });
    showLess = () => this.setState({ showAll: false });
    render() {
        const { content, limit } = this.props;
        const { showAll } = this.state;

        if (content.length <= limit) {
            // there is nothing more to show
            return <div className={this.props.className + " default"}>
                <P>
                    {this.props.renderhtml == true &&
                        renderHTML(content)
                    }
                    {this.props.renderhtml != true &&
                        content
                    }

                </P>
            </div>
        }

        if (showAll) {
            // We show the extended text and a link to reduce it
            return <div>
                <div className={this.props.className + " readless"}>
                    <P>
                        {this.props.renderhtml == true &&
                            renderHTML(content)
                        }
                        {this.props.renderhtml != true &&
                            content
                        }

                    </P>
                </div>
                <div className="toggler-data readless">
                    <button onClick={this.showLess}>Read less</button>
                </div>
            </div>
        }
        // In the final case, we show a text with ellipsis and a `Read more` button
        const toShow = content.substring(0, limit) + "...";
        return <div>
            <div className={this.props.className + " readmore"}>
                <P>

                    {this.props.renderhtml == true &&
                        renderHTML(toShow)
                    }
                    {this.props.renderhtml != true &&
                        toShow
                    }
                </P>
            </div>
            <div className="toggler-data readmore">
                <button onClick={this.showMore}>Read more</button>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
    };
}

const connectedMostRaisedPage = connect(mapStateToProps, null, null, {
    pure: false
})(LongText);

export { connectedMostRaisedPage as LongText };
